import { EditableLabel } from '../EditableLabel';
import { LABEL_OFFSET_CORNER_SIGN } from './editableCornerLabel.constants';

import { DEFAULT_CORNER_RADIUS } from '~/core/constants';
import { getOutlinePointsFromShape } from '~/core/helpers';
import { CornerInfo, DrawingShape } from '~/core/models';
import { enforceRadiusConstraints, getCornerLabelPosition } from '~/core/utils';
import theme from '~/theme/theme';

export type EditableCornerLabelHandler = (
  editedCorner: CornerInfo,
  shape: DrawingShape,
  size: number
) => void;

const { palette } = theme.light;

export class EditableCornerLabel extends EditableLabel {
  constructor(
    parentShape: DrawingShape,
    rootCornerInfo: CornerInfo,
    label: string,
    onEdit: EditableCornerLabelHandler,
    canvas: fabric.Canvas,
    interiorColor: string = palette.black,
    index: number
  ) {
    super(parentShape, canvas, interiorColor, label, rootCornerInfo);

    if (!rootCornerInfo.size) {
      console.error(
        'Tried to init editableLabel with undefined radius',
        rootCornerInfo
      );
    }
    this.measurementText.fontSize = 2.5;
    this.labelText.fontSize = 2.5;

    //make a new corner inheriting content from the previously existing corner with a new radius and enforcing pricing values.
    this.measurementText.on('editing:exited', () => {
      const attemptedRadius = this.measurementText.text
        ? parseFloat(this.measurementText.text)
        : NaN;
      const radius = isNaN(attemptedRadius)
        ? rootCornerInfo.size
        : enforceRadiusConstraints(rootCornerInfo, attemptedRadius);

      onEdit(
        rootCornerInfo,
        parentShape,
        radius ?? rootCornerInfo.size ?? DEFAULT_CORNER_RADIUS
      );
    });

    const boundRcLabel = this.labelText.getBoundingRect();
    const boundRcMeasurement = this.measurementText.getBoundingRect();

    const outlinePoints = getOutlinePointsFromShape(parentShape);
    const beforeIndex = index - 1 < 0 ? outlinePoints.length - 1 : index - 1;
    const afterIndex = index + 1 > outlinePoints.length - 1 ? 0 : index + 1;

    const cornerPos = getCornerLabelPosition(
      outlinePoints[beforeIndex],
      outlinePoints[index],
      outlinePoints[afterIndex],
      boundRcLabel.width + boundRcMeasurement.width,
      boundRcLabel.height
    );

    this.measurementText.left = cornerPos.x;
    this.measurementText.top = cornerPos.y;
    this.labelText.left = cornerPos.x - LABEL_OFFSET_CORNER_SIGN;
    this.labelText.top = cornerPos.y;
    rootCornerInfo.labelText = this.labelText;
    rootCornerInfo.labelMeasure = this.measurementText;
    canvas.add(this.measurementText);
    canvas.add(this.labelText);
  }
}
